(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _this = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var common = function ($) {
  'use strict';
  /**=============================================================
   * Helper functions
   =============================================================*/

  function handleizeColorValue(str) {
    str = str.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"]; // For the old browsers

    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str;
  }

  ;
  /**
   * Retrieve the products first color value
   * @param {string} relatedProductHandle 
   * @param {string} fn 
   */

  function getColorValue(relatedProductHandle, fn) {
    var productHandle = relatedProductHandle.toString();
    if (productHandle === '') return;
    var relatedProductJson = '/products/' + productHandle + '.js';
    $.getJSON(relatedProductJson, function (product) {
      product.options.forEach(function (option) {
        // check if we even have color options
        if (option.name === "Color" || option.name === "Colour") {
          fn(option.values[0]);
        }
      });
    });
  }
  /**
   * Handlebar Helper functions
   */


  Handlebars.registerHelper('times', function (n, block) {
    var accum = '';

    for (var i = 1; i <= n; ++i) {
      accum += block.fn(i);
    }

    return accum;
  });
  Handlebars.registerHelper("when", function (operand_1, operator, operand_2, options) {
    var operators = {
      'eq': function eq(l, r) {
        return l == r;
      },
      'noteq': function noteq(l, r) {
        return l != r;
      },
      'gt': function gt(l, r) {
        return Number(l) > Number(r);
      },
      'or': function or(l, r) {
        return l || r;
      },
      'and': function and(l, r) {
        return l && r;
      },
      '%': function _(l, r) {
        return l % r === 0;
      }
    },
        result = operators[operator](operand_1, operand_2);
    if (result) return options.fn(this);else return options.inverse(this);
  });
  /**=============================================================
   * Watch for ajaxProduct event 
   =============================================================*/

  var initItemAddedCallback = function initItemAddedCallback() {
    $('body').on('added.ajaxProduct', function (evt, returnFocusEl) {
      // execute add to cart flow
      updateAndOpenCart(true);
    }.bind(_this));
  };
  /**=============================================================
   * This will update and execute the default add to cart flow
   * @param {boolean} buildCart 
   =============================================================*/


  var updateAndOpenCart = function updateAndOpenCart(buildCart) {
    var CART_INSTANCE = new theme.CartDrawer();
    var addToCartFeedbackMsg = $(".message--item-added");
    var deliveryDateMsg = $(".message--delivery-date");
    theme.cart.getCart().then(function (cart) {
      var cartCount = cart.item_count;
      var cartCountHtml = '<small>' + cartCount + '</small>';
      $(".cart_count").html(cartCountHtml);

      if (buildCart) {
        this.buildCart(cart, true); // hide default

        deliveryDateMsg.addClass("hide"); // show feedback

        addToCartFeedbackMsg.removeClass("hide"); // reset state

        var setIntervalSuccessMessage = setTimeout(function () {
          addToCartFeedbackMsg.addClass("hide");
          deliveryDateMsg.removeClass("hide");
          clearTimeout(setIntervalSuccessMessage);
        }, 4000);
      }

      CART_INSTANCE = null; // Save memory
    }.bind(CART_INSTANCE));
  };
  /**
   * Initialize the Product Page SizeChart
   */


  var initSizeChart = function initSizeChart() {
    var $openTrigger = $("#sizeChartTrigger"); // only run code when elements exists

    if ($openTrigger.length === 0) return;
    var isActiveModalClass = "modal--is-active";
    var isOpenModalClass = "modal-open";
    var sizeChartButton = ".sizeChartButton";
    var $modalInner = $(".modal__inner").closest("#SizeChartPopup");
    var $modalCloseTrigger = $(".modal__close");
    var $sizeChartModal = $("#SizeChartPopup"); // open the sizechart on click

    $openTrigger.on("click", function (event) {
      if ($(event.target).closest(sizeChartButton).length) {
        $sizeChartModal.addClass(isActiveModalClass);
        $sizeChartModal.addClass(isOpenModalClass); // attach close handlers

        $modalInner.on("click", function (event) {
          if (!$(event.target).closest(".modal__inner").length) {
            $sizeChartModal.removeClass(isActiveModalClass);
            $sizeChartModal.removeClass(isOpenModalClass);
          }
        });
      }
    }); // inits the close sizechart buttons

    $modalCloseTrigger.on("click", function (event) {
      if ($(event.target).closest(".modal__close").length) {
        $sizeChartModal.removeClass(isActiveModalClass);
        $sizeChartModal.removeClass(isOpenModalClass);
      }
    }); // inits the auto-zoom for the sizechart

    function initChartZoom() {
      var $zoomSelector = $('.image-zoom');
      if ($zoomSelector.length === 0) return;
      $zoomSelector.wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom({
        url: $(this).find('img').attr('data-zoom')
      });
    }

    initChartZoom();
  };
  /**
   * Watch and Alert for Free shipping amount in the Cart
   */


  $(document).on("updateCart.ajaxcart", function (e, cart) {
    var freeShippingAmount = parseInt(theme.settings.cartFreeShipping.amount); // free shipping calculator

    var $container = $("#CartDrawer").find(".message--delivery-date");
    var $delivery_message = $container.find("> span");

    if (!$container.find("#freeShippingCalc").length) {
      $container.append('<div id="freeShippingCalc" style="position: relative;"></div>');
    }

    var amount = freeShippingAmount * 100 - cart.total_price;
    var progress = cart.total_price / freeShippingAmount;
    var layout = "\n      <span>".concat(theme.settings.cartFreeShipping.calcText, " ").concat(theme.Currency.formatMoney(amount, theme.settings.moneyFormat), "</span>\n      <span class=\"progress\" style=\"position: absolute; z-index: -1; left: 0px; background: #528267; height: 100%; width: ").concat(progress, "%;\"></span>\n    ");

    if (cart.total_price / 100 >= freeShippingAmount) {
      $("#freeShippingCalc").hide();
      $delivery_message.show();
    } else {
      $delivery_message.hide();
      $("#freeShippingCalc").html(layout).show();
    } // free shipping alert


    if (cart.total_price / 100 >= freeShippingAmount) {
      var _$container = $("#CartContainer").find(".drawer__footer");

      if (!_$container.find("#freeShippingAlert").length) {
        var _layout2 = "\n        <div class=\"grid grid--full shipping-alert\">\n          <div class=\"grid__item one-half\">\n            <p class=\"ajaxcart__subtotal\">Shipping</p>\n          </div>\n          <div class=\"grid__item one-half text-right\">\n            <div id=\"freeShippingAlert\" class=\"ajaxcart__price\"></div>\n          </div>\n        </div>\n        ";

        _$container.prepend(_layout2);
      }

      var _layout = "\n        <span style=\"display: block;\">".concat(theme.settings.cartFreeShipping.text, "</span>\n      ");

      $("#freeShippingAlert").html(_layout);
    } else {
      $("#freeShippingAlert").remove();
    }
  });
  /**
   * Functions for Cart Free gift
   */

  var freeGiftModal;
  $(document).on("updateCart.ajaxcart", function (e, cart) {
    freeGift(cart);
  });

  var freeGift = function freeGift(cart) {
    if (!$("#free-gift-add-button").length) return;
    $("#free-gift").show();
    var freeGiftCartAmount = theme.settings.cartFreeGift.cartAmount;
    var amountReached = cart.total_price / 100;

    if (amountReached >= freeGiftCartAmount) {
      $("#free-gift-progress").hide();
      $("#free-gift-blur").hide();
    } else {
      //update progress bar
      var amount = freeGiftCartAmount * 100 - cart.total_price;
      var progress = cart.total_price / freeGiftCartAmount;
      var layout = "\n        <span>".concat(theme.Currency.formatMoney(amount, theme.settings.moneyFormat), " ").concat(theme.settings.cartFreeGift.amountText, "</span>\n        <span class=\"progress\" style=\"position: absolute; z-index: -1; top: 0; left: 0px; background: #027736; height: 100%; width: ").concat(progress, "%;\"></span>\n      ");
      $("#free-gift-progress").html(layout);
      $("#free-gift-progress").show();
      $("#free-gift-message").hide();
    } //move free gift modal from drawer cart into body (appearance fix)


    $("#free-gift__modal-container").appendTo("body");
    var giftModalId = "ProductModal-" + $("#free-gift-add-button").data("product-id");
    freeGiftModal = new theme.Modals(giftModalId, giftModalId); //Allow only one gift and hide gift qty field

    $("#CartDrawer").find(".ajaxcart__product").each(function () {
      var $product_container = $(this);
      var isGift = false;
      $product_container.find(".ajaxcart__product-meta").each(function () {
        if ($(this).html().includes("GiftProduct")) {
          isGift = true;
          $product_container.find(".ajaxcart__qty").hide();
        }
      });

      if (isGift) {
        // gift already in the cart
        $("#free-gift").hide();
      }
    }); //watch if cart amount changed and remove gift

    if (amountReached < freeGiftCartAmount) {
      cart.items.forEach(function (product) {
        console.log("here", product);

        if (product.properties && product.properties.GiftProduct) {
          var data = {
            updates: _defineProperty({}, product.variant_id, 0)
          };
          $.ajax({
            url: '/cart/update.js',
            data: data,
            dataType: "json",
            success: function success(response) {
              console.log("Gift product removed because of low cart amount");
              $("#CartDrawer").find("div[data-vid=" + product.variant_id + "]").remove(); // remove from the cart
              //rebuild cart (brings glitches with multiple ajax calls)
              //let CART_INSTANCE = new theme.CartDrawer();
              //theme.cart.getCart().then(
              //  function (cart) {
              //    this.buildCart(cart, false);
              //    CART_INSTANCE = null; // Save memory
              //  }.bind(CART_INSTANCE)
              //);
            }
          });
        }
      });
    }
  };

  window.freeGiftAddVariant = function (btn) {
    console.log("ok");
    var variant_id = btn.closest('.ajaxcart__product-btn').querySelector("#free-gift-variant").value;
    window.freeGiftAdd(variant_id);
  };

  window.freeGiftAdd = function (variant_id) {
    $.ajax({
      url: '/cart/add.js',
      data: {
        items: [{
          quantity: 1,
          id: variant_id,
          properties: {
            GiftProduct: "Yes"
          }
        }]
      },
      dataType: "json",
      success: function success(response) {
        //rebuild cart
        var CART_INSTANCE = new theme.CartDrawer();
        theme.cart.getCart().then(function (cart) {
          this.buildCart(cart, false);
          CART_INSTANCE = null; // Save memory
        }.bind(CART_INSTANCE)); //show message in a cart

        var deliveryDateMsg = $("#CartDrawer").find(".message--delivery-date");
        var addToCartFeedbackMsg = $("#CartDrawer").find(".message--item-added");
        deliveryDateMsg.addClass("hide");
        addToCartFeedbackMsg.removeClass("hide");
        var setIntervalSuccessMessage = setTimeout(function () {
          addToCartFeedbackMsg.addClass("hide");
          deliveryDateMsg.removeClass("hide");
          clearTimeout(setIntervalSuccessMessage);
        }, 4000);
      }
    });
    freeGiftModal.close();
  };
  /**
   * Custom function to open cart
   * @param {boolean} build_cart 
   */


  window.customOpenCart = function (build_cart) {
    if (build_cart !== true) return;
    var CART_INSTANCE = new theme.CartDrawer();
    theme.cart.getCart().then(function (cart) {
      this.buildCart(cart, true);
      CART_INSTANCE = null; // Save memory
    }.bind(CART_INSTANCE));
  };
  /**
   * custom open_cart function
   * can be called directly or via custom parameter
   * Param: ?open_cart_drawer=true
   */


  var openCartDrawerFunc = function openCartDrawerFunc() {
    var paramId = 'open_cart_drawer';
    var getCurrentQueryString = window.location.search;
    if (getCurrentQueryString === 0 || getCurrentQueryString === 'undefined') return; // parse query string to

    var currentUrlParams = new URLSearchParams(getCurrentQueryString);
    if (currentUrlParams.has(paramId) === false) return;
    var getCartOpenParam = currentUrlParams.get(paramId);
    if (getCartOpenParam === 'false') return; // opencart drawer

    window.customOpenCart(true);
  };
  /**
   * Product swatcher images
   * @param string currentClusterTag - tag for search products for
   * @param string currentHandle - handle for exclude current product 
   */


  function SingleProductImageSwatcher($container, currentClusterTag, currentHandle) {
    var $swatcherContainer = $container.find(".product-swatcher-images__variants"); // available colors will be appened here

    if ($container.hasClass("loaded")) return; //already loaded

    var query = currentClusterTag + '&resources[type]=product&resources[limit]=9&resources[options][fields]=tag';
    fetch("/search/suggest.json?q=" + query).then(function (response) {
      return response.json();
    }).then(function (suggestions) {
      var products = suggestions.resources.results.products;

      if (products.length < 2) {
        $("#product-swatcher-images").hide(); // hide if no any products except current one found

        return;
      }

      products.forEach(function (product, k) {
        if (product.handle == currentHandle) return;
        var parts = product.title.split(" / "); // use title for fetch color

        var color = '';

        if (parts.length > 1) {
          color = parts[1];
        }

        var product_link = product.url.split("?")[0] + ".json";
        fetch(product_link).then(function (response) {
          return response.json();
        }).then(function (data) {
          var image = data.product.images[1] && data.product.images[1].src || product.image;
          image = image.split("?")[0].replace(".jpg", "_100x.jpg");
          var layout = "\n              <div class=\"product-swatcher-images__variant\">\n                <a href=\"/products/".concat(product.handle, "\"\n                  class=\"image\"\n                  title=\"").concat(product.title, "\"\n                  style=\"background-image: url('").concat(image, "')\"\n                >\n                </a>\n                <span class=\"color\">\n                  &nbsp; ").concat(color, "\n                </span>\n              </div>\n            ");
          $swatcherContainer.append(layout);
        });
      });

      if ($swatcherContainer.height() > 150) {
        $swatcherContainer.parent().addClass("multiline"); // need for show/hide "Show more" button

        $(".product-swatcher-images__show-more").bind("click", function () {
          $swatcherContainer.parent().toggleClass("expanded");
        });
      }

      setTimeout(function () {
        $container.addClass("loaded").removeClass("loading");
      }, 1000);
    });
  } // Image swatcher in quick view


  $("body").on("productModalOpen", function () {
    var $modal = $(".modal--is-active");
    var wait = 0;
    var waitForLoad = setInterval(function () {
      var $container = $modal.find(".product-swatcher-images-container");
      var currentClusterTag = $container.data("current-cluster-tag");
      var currentHandle = $container.data("current-handle");

      if (typeof currentClusterTag !== 'undefined') {
        SingleProductImageSwatcher($container, currentClusterTag, currentHandle); // parameters are defined in the liquid template file
      }

      if ($container.length || wait > 1000) {
        clearInterval(waitForLoad);
      }

      wait += 50;
    }, 50);
  }); // Image swatcher native

  $(".product-swatcher-images-container").each(function () {
    var $container = $(this);
    var currentClusterTag = $container.data("current-cluster-tag");
    var currentHandle = $container.data("current-handle");

    if (typeof currentClusterTag !== 'undefined') {
      SingleProductImageSwatcher($container, currentClusterTag, currentHandle); // parameters are defined in the liquid template file
    }
  });
  /**
   * Fire events on document ready and bind other events
   *
   * @since   1.0.0
   */

  var ready = function ready() {
    initItemAddedCallback();
    initSizeChart();
    openCartDrawerFunc();
  };
  /**
   * Only expose the ready function to the world
   */


  return {
    ready: ready
  };
}(jQuery);

jQuery(common.ready);

},{}]},{},[1])

